import { useMutation, useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import api from "../../axios.config";
import {
  FindSaltRequest,
  FindSaltResponse,
  GetAIAnswerParams,
  GetAIAnswerSuccess,
  GetAISessionSuccess,
} from "./ai.type";

export const useGetAISession = () => {
  return useQuery<GetAISessionSuccess, AxiosError<GlobalErrorResponse>>({
    queryKey: ["medico-ai-session"],
    queryFn: async () =>
      api
        .get(`${process.env.REACT_APP_API_MEDICO_AI_GET_SESSION}`)
        .then((r) => r.data),
    staleTime: Infinity, // Keep the session ID as long as the page is open
    refetchOnWindowFocus: false,
  });
};

export const useGetAIAnswer = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: GetAIAnswerSuccess) => void;
  onError?: (error: AxiosError<GlobalErrorResponse>) => void;
} = {}) => {
  return useMutation<
    GetAIAnswerSuccess,
    AxiosError<GlobalErrorResponse>,
    GetAIAnswerParams
  >({
    mutationFn: async ({ sessionId, query }) => {
      return api
        .get(
          `${process.env.REACT_APP_API_MEDICO_AI_GET_ANSWERS}/${sessionId}`,
          {
            params: {
              query,
            },
          }
        )
        .then((r) => r.data);
    },
    onSuccess,
    onError,
  });
};

export const useFindSaltComposition = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: FindSaltResponse) => void;
  onError?: (error: AxiosError<GlobalErrorResponse>) => void;
} = {}) => {
  return useMutation<
    FindSaltResponse,
    AxiosError<GlobalErrorResponse>,
    FindSaltRequest
  >({
    mutationFn: async (payload) => {
      return api
        .post(
          `${process.env.REACT_APP_API_MUKUNDA_AI_SALTINFO_SEARCH}`,
          payload
        )
        .then((r) => r.data);
    },
    onSuccess,
    onError,
  });
};
